export default {
  BACKEND_SOCKET_HOST: 'vr-events.radio.dpgmedia.cloud',
  BACKEND_SOCKET_PORT: 6001,
  BACKEND_SOCKET_KEY: 'dpgradio-vr-events-room',
  
  BACKEND_API_URL: 'https://vr-events.radio.dpgmedia.cloud/api',
}
